import { render, staticRenderFns } from "./tabs2.vue?vue&type=template&id=5665e7f9&scoped=true"
import script from "./tabs2.vue?vue&type=script&lang=js"
export * from "./tabs2.vue?vue&type=script&lang=js"
import style0 from "./tabs2.vue?vue&type=style&index=0&id=5665e7f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665e7f9",
  null
  
)

export default component.exports